import Input from '../../components/input/Input'
import Typography from '../../components/typography/Typography'
// import { Typography } from '@mui/material';
import appLogo from '../../assets/logo/app-logo.svg'
import wavingHand from '../../assets/icons/waving-hand.svg'
import { useDispatch, useSelector } from 'react-redux'
import './login.scss'
import { useEffect, useState } from 'react'
import useScreenSize from '../../hooks/useScreenSize'
import Button from '../../components/button/Button'
import validateField from '../../utility/validation'
import { useNavigate } from 'react-router-dom'
import { setPageModeOtp, setUserOtp, setUserPhone } from '../../store/slice/auth/authenticationSlice'
import useThrottle from '../../hooks/useThrottle.js'
import { loginWithOTP } from '../../store/builders/auth/auth.builders.js'
import { UI_CONSTANT } from '../../utility/constants.js'

function Login() {
  const screenSize = useScreenSize()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { loading, pageModeOtp, userPhone, userOtp } = useSelector((state) => state.auth) || {}
  const [isFormValid, setIsFormValid] = useState(false)
  const [load, setLoad] = useState(false)
  const [formData, setFormData] = useState({
    email: userPhone ? userPhone : '',
  })
  const [errors, setErrors] = useState({})
  const [blur, setBlur] = useState(false)

  useEffect(() => {
    if (window.location.pathname == '/login') {
      dispatch(setPageModeOtp('number'))
      dispatch(setUserOtp(null))
    }
  }, [])

  useEffect(() => {
    setIsFormValid(formData.email.trim() !== '' && !errors.email)
  //   setErrors((prevData) => ({
  //     ...prevData,
  //     email: '',
  //     password: '',
  //   }))

  }, [formData.email, errors.email, dispatch])

  const handleLogin = async () => {
    if (pageModeOtp === 'number') {
      const email = formData.email
      dispatch(setUserPhone(formData.email))
      setLoad(true)
      dispatch(loginWithOTP({ email, navigate }))
    }
  }

  const handleThrottleLogin = useThrottle(handleLogin, 2000)

  const handleChange = (e) => {
    const { name, value } = e.target
    // dispatch(setUserPhone(null))
    setBlur(false)
    //setBlur(true)
    const error = validateField(name, value)
    setFormData({
      ...formData,
      [name]: value,
    })
    setErrors({
      ...errors,
      [name]: error,
    })
  }
  const handleBlur = (e) => {
    setBlur(true)
    const { name, value } = e.target
    const error = validateField(name, value)
    setErrors({
      ...errors,
      [name]: error,
    })
  }

  const handleEnterClick = (e) => {
    if ((e.key === 'Enter' || e.keyCode === 13) && isFormValid && !Object.values(errors).some((error) => error)) {
      handleThrottleLogin()
    }
  }

  return (
    <>
      <div className='wrapper'>
        <div className='container flex justify-center align-center'>
          <div className='section logo-section flex justify-center align-center'>
            <div className='container'>
              <img src={appLogo} alt='App Logo' />
            </div>
          </div>
          <div className='section login-section flex justify-center align-center'>
            <div className={`container ${screenSize} flex flex-column justify-evenly`}>
              <Typography
                onClick={() => navigate('/contact-us')}
                textColor='red'
                textType='forgot'
                textWeight='400'
                style={{
                  cursor: 'pointer',
                  justifyContent: 'end',
                  position: 'absolute',
                  bottom: '20px',
                  right: '20px',
                }}
              >
                Contact us
              </Typography>
              <WelcomeText
                resetOtp={userOtp}
                title='Welcome Back'
                message='Log in to your account below'
                formData={formData}
                pageModeOtp={pageModeOtp}
                setFormData={setFormData}
                userPhone={userPhone}
                loading={loading}
              />
              <div className='input-wrapper flex flex-column justify-center align-center'>
                {pageModeOtp === 'number' && (
                  <MobileNumberInput
                    errors={errors}
                    handleChange={handleChange}
                    formData={formData}
                    handleBlur={handleBlur}
                    blur={blur}
                    handleLogin={handleLogin}
                    handleEnterClick={handleEnterClick}
                  />
                )}
              </div>
              <ButtonGroup
                navigate={navigate}
                setFormData={setFormData}
                handleThrottleLogin={handleThrottleLogin}
                loading={loading}
                isFormValid={isFormValid}
                // timerCompleted={timerCompleted}
                errors={errors}
                pageModeOtp={pageModeOtp}
                onKeyDown={handleEnterClick}
              />
              <Typography
                onClick={() => navigate('/privacy-policy')}
                textColor='red'
                textType='forgot'
                textWeight='400'
                style={{
                  cursor: 'pointer',
                  justifyContent: 'end',
                  position: 'absolute',
                  bottom: '20px',
                  right: '120px',
                }}
              >
                Privacy Policy
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Login

export function MobileNumberInput({ errors, formData, handleChange, handleBlur, blur, handleEnterClick }) {
  // const handleThrottleLogin = useThrottle(handleLogin, 2000)

  const handleKeyPress = (e) => {
    // Allow only numeric characters (0-9) and specific keys (backspace, delete, arrow keys, etc.)
    const isValidInput = /^\d*$/.test(e.key)
    if (!isValidInput) {
      e.preventDefault()
    }
  }


  return (
    <>
      <div className='mobile-input'>
        <Input
          // monileNumber={true}
          // maxLength={10}
          placeholder='Enter your Email'
          name='email'
          icon='email'
          value={formData.email}
          error={errors.email}
          onChange={handleChange}
          // onKeyPress={handleKeyPress}
          onBlur={(e) => handleBlur(e)}
          blur={blur}
          onKeyDown={handleEnterClick}
        />
      </div>
    </>
  )
}

export function WelcomeText({ message, title, hideHandIcon, pageModeOtp, resetOtp, userPhone, loading }) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const handleChange = () => {
    dispatch(setPageModeOtp('number'))
    navigate('/login')
    dispatch(setUserOtp(null))
    // setPhone(click)
    // setFormData((prevData) => ({
    //   ...prevData,
    //   phone: '',
    // }))
  }

  return (
    <div className='heading-wrapper flex flex-column justify-center'>
      <Typography justify='left' textType='welcome' textWeight='700'>
        {title}
        {!hideHandIcon && (
          <span>
            <img src={wavingHand} alt='Waving Hand' />
          </span>
        )}
      </Typography>
      <Typography justify='left' textColor='red' textType='description'>
        {message}
      </Typography>
      {pageModeOtp == 'otp' && (
        <>
          <Typography justify='left' textColor='black' textType='description'>
            {resetOtp == 'reset' ? 'A New OTP' : '4 digit OTP'} has been sent to your email {userPhone}
          </Typography>
          <div className='flex' style={{ gap: '5px' }}>
            <div>Email </div>
            <div
              style={{
                cursor: loading ? 'not-allowed' : 'pointer',
                color: 'red',
                fontWeight: '600',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
              }}
              onClick={!loading ? handleChange : undefined}
            >
              Change
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export function ButtonGroup({
  type = 'button',
  handleThrottleLogin,
  loading,
  isFormValid,
  errors,
  pageModeOtp,
  onKeyDown,
}) {
  const hasErrors = Object.values(errors).some((error) => error)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const handleNavigate = () => {
    dispatch(setUserPhone(null))
    if (pageModeOtp === 'otp') {
      navigate('/login')
      dispatch(setPageModeOtp('number'))
      dispatch(setUserOtp(null))
      // setFormData((prevData) => ({
      //   ...prevData,
      //   phone: '',
      // }))
    } else {
      navigate('/login-email')
    }
  }

  return (
    <>
      <div className='button-wrapper flex flex-column justify-center align-center'>
        <>
          <Button
            onClick={handleThrottleLogin}
            customClassName={'otp-login'}
            disabledBgColor={'#ee4e56'}
            disabled={!isFormValid || loading || hasErrors}
            onKeyDown={onKeyDown}
            type={type}
          >
            <Typography textColor='white' textType='login-button' textWeight='700'>
              {loading ? UI_CONSTANT.LOADING : pageModeOtp === 'otp' ? 'Verify OTP' : 'Send OTP'}
            </Typography>
          </Button>

          {pageModeOtp != 'otp' && (
            <>
              <Typography textType='login-button' textColor='red' textWeight='600'>
                OR
              </Typography>
              <Button
                disabledBgColor={'otp-login'}
                onClick={() => {
                  handleNavigate()
                }}
                variant='outlined'
                disabled={loading}
              >
                <Typography textColor='red' textType='login-button' textWeight='700'>
                  {pageModeOtp === 'otp' ? 'Login' : 'Login with Email and Password'}
                </Typography>
              </Button>
              {/* <Button onClick={()=> navigate('/contact-us')} variant=''>Contact us</Button> */}
            </>
          )}
        </>
      </div>
    </>
  )
}
